module.exports = __webpack_public_path__ + "static/media/live10_11_2017.42afb04e.jpg";